import { IFormField, IFormFieldRenderer } from '@migrate/utils/form/form'

export class SelectRenderer implements IFormFieldRenderer {
  render(field: IFormField) {
    const { value } = field
    if (value) {
      return Array.isArray(value) ? this.renderArray(field, value) : this.renderOption(field, value)
    }
    return field.value
  }

  renderArray(field: IFormField, values: string[]) {
    const all = values.map((value: string) => {
      return this.renderOption(field, value)
    })
    return all.join(', ')
  }

  renderOption(field: IFormField, value: string) {
    field.meta!.options!.forEach((option) => {
      const displayName = option.model?.displayName && option.model.displayName
      if (value === option.value || value?.toString() === option.value?.toString()) {
        value = displayName ? displayName : option.label
      } else if (displayName && displayName.startsWith(value)) {
        value = displayName
      }
    })
    return value
  }
}
